import { createContext, useContext } from "react";
import { Absence } from "../../models/calendar/Absence.model";

export const AbsencesContext = createContext<{
  absences: Absence[];
  setAbsences: React.Dispatch<React.SetStateAction<Absence[]>>;
} | undefined>(undefined);

export const useAbsences = () => {
  const context = useContext(AbsencesContext);
  if (!context) {
    throw new Error("useAbsences must be used within an AbsencesContext.provider");
  }
  return context;
};
